import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';
import { DeparturePicker } from '../components/departure-picker.js';

$(() => {
    detailsPackage.init();
})

const detailsPackage = {
    $details: null,
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        time: null,
        dateFrom: null, 
        dateTo: null, 
        aDateFrom: null, 
        aDateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
        dynamicPackage: 1,
    },
    defaults: {
        guests: null, 
        dates: null,
        time: null,
        dateFrom: null, 
        dateTo: null, 
        aDateFrom: null, 
        aDateTo: null, 
        objectGroupId: 1,
        dynamicPackage: 1,
    },
    travelProgram: '',
    init() {
        this.$details = $('.page-type-details');
        this.params.objectGroupId = this.$details.attr('data-objectgroupid');
        
        if(! this.$details[0] || this.params.objectGroupId != 1) {
            return;
        }
        if(+this.$details.attr('data-dynamicpackage') != this.params.dynamicPackage) {
            return;
        }

        this.params.objectId = this.$details.attr('data-objectid');
        this.params.referenceId = this.$details.attr('data-referenceid');
        this.params.calcErrorMessages = $('[data-calcErrorMessages]')[0] ? JSON.parse($('[data-calcErrorMessages]').attr('data-calcErrorMessages')) : null;
        this.params.isBrosTravel = $('[data-isBrosTravel]').length ? $('[data-isBrosTravel]').attr('data-isBrosTravel') : null;
        this.allowedServices = JSON.parse($('[data-allowedservices]').attr('data-allowedservices'));
        this.params.showCart = $('[data-showCart]').length ? +$('[data-showCart]').attr('data-showCart') : true;

        this.getParams();

        this.$form = $('.availability-form');
        this.form = this.$form[0];

        $.post('/services/dynamic_package_availability_form_data/', {
            objectId: this.params.referenceId,
            dynamicPackage: 1,
            language: functions.getLang(),
            flightAvailabilityStatus: true,
        }).always(response => {
            response = response ? JSON.parse(response) : null;
            if(response.status) {

                const prepared = this.getPackageDepartures(response.data.items, response.data.flights);
                const serviceCodes = response.data.serviceCodes;
                const serviceOptionals = response.data.serviceOptionals;

                if ( ! this.params.optionals && response.data.serviceOptionalsDefault) {

                    let serviceOptionalsDefault;
                    this.allowedServices.forEach((allowedService) => {
                        if (allowedService.key === response.data.serviceOptionalsDefault) {
                            serviceOptionalsDefault = allowedService.supplementKey;
                        }
                    });

                    console.log(serviceOptionalsDefault);
                    if (serviceOptionalsDefault) this.params.optionals = serviceOptionalsDefault;
                }

                const $service = $("[name='serviceCode']");
                const $optionals = $("[name='optionals']");
                const $nights = $("[name='nights']");
                const $serviceWrapper = $service.parents('.service-code-wrapper');
                serviceCodes.length || serviceOptionals.length ? $serviceWrapper.removeClass('d-none') : $serviceWrapper.addClass('d-none');

                this.enable = prepared.enable;
                this.flights = prepared.flights;
                this.prices = prepared.prices;

                let nights = this.enable.map(i => i['nights']);
                nights = nights.filter((value, index, array) => array.indexOf(value) === index).sort((a, b) => { return a - b });

                if(nights.length) {
                    $('.package-duration-wrapper').removeClass('d-none');
                    $('.package-duration').text(nights.join(', ') + ' noćenja');

                    let _nights = [];
                    nights.forEach((night, key) => {
                        _nights.push({id: night, text : night})

                        if ( ! this.params.nights) {
                            this.params.nights = night;
                        }
                    });

                    $nights.select2({
                        data: _nights,
                        minimumResultsForSearch: -1
                    });

                    setTimeout(() => $nights.val(this.params.nights).trigger('change'));

                } else {
                    $('.package-duration-wrapper').addClass('d-none');
                }



                const $detailsDatepicker = $("#details-datepicker");
                $detailsDatepicker.attr('data-departures', JSON.stringify(this.enable));
                $detailsDatepicker.attr('data-flights', JSON.stringify(this.flights));
                $detailsDatepicker.attr('data-prices', JSON.stringify(this.prices));

                $detailsDatepicker.find('[data-input]').each((i, elem) => {
                    elem._departurePicker = new DeparturePicker(elem);
                });

                if (serviceOptionals.length) {

                    let _serviceOptionals = [];
                    _serviceOptionals.push({id: 'base', text: '----'});
                    serviceOptionals.forEach((optional, key) => {
                        this.allowedServices.forEach((allowedService) => {
                            if (allowedService.key == optional){
                                _serviceOptionals.push({id: allowedService.supplementKey, text: allowedService.text});
                            }
                        });
                    });

                    $optionals.select2({
                        data: _serviceOptionals,
                        minimumResultsForSearch: -1
                    });

                    if (this.params.optionals) {
                        setTimeout(() => $service.val(this.params.optionals).trigger('change'));
                    }
                } else {

                    serviceCodes.forEach((serviceCode, key) => {
                        this.allowedServices.forEach((allowedService) => {
                            if (allowedService.key == serviceCode){
                                //serviceCodes[key] = allowedService;
                                serviceCodes[key] = {id: allowedService.key};
                                serviceCodes[key].text = allowedService.text;

                                if ( ! this.params.serviceCode) {
                                    this.params.serviceCode = allowedService.key;
                                    this.params.serviceCodeId = allowedService.id;
                                }

                            }
                        });
                    });

                    $service.select2({
                        data: serviceCodes,
                        minimumResultsForSearch: -1
                    });

                    setTimeout(() => $service.val(this.params.serviceCode).trigger('change'));
                }

                /*$('[id^=unitModal], [id^=pricelistTableModal]').on('shown.bs.modal', e => {
                    const $target = $(e.currentTarget);
                    const $pricelistServiceWrapper = $target.find('.service-code-wrapper');
                    const $pricelistService = $pricelistServiceWrapper.find("[name='serviceCode']");
                    serviceCodes.length ? $pricelistServiceWrapper.removeClass('d-none') : $pricelistServiceWrapper.addClass('d-none');

                    $pricelistService.select2({
                        data: serviceCodes,
                        minimumResultsForSearch: -1
                    });

                    setTimeout(() => $pricelistService.val(this.params.serviceCodeId).trigger('change'));
                });*/

                this.setDefaultDeparture();
                this.params.dateFrom && this.showFlightTickets();
                functions.setFormData(this.form, this.params);
                this.setPrices();
                this.getCalculation();

                this.$form.on('submit', e => {
                    e.preventDefault();
                    e.stopPropagation();
                });
                this.$form.on('change', e => {
                    e.preventDefault();
                    const $target = $(e.currentTarget);
                    const data = functions.getFormData($target);
        
                    this.params.dateFrom = data.dateFrom;
                    this.params.dateTo = data.dateTo;
                    this.params.guests = data.guests;
                    this.params.serviceCode = data.serviceCode;
                    this.params.optionals = data.optionals;
                    this.params.time = data.time;
        
                    functions.setUrlData({'dateFrom': this.params.dateFrom, 'dateTo': this.params.dateTo, 'guests': this.params.guests, 'serviceCode': this.params.serviceCode, 'optionals': this.params.optionals, 'time': this.params.time }, true, true);
                    //this.getCalculation();
                });
        
                // check availability on form change (not only on btn click)
                /*$('[name="dateFrom"], [name="dateTo"], [name=guests], [name=serviceCode]').on('change', () => {
                    const data = functions.getFormData(this.$form);
                    if ( data.dateFrom && data.dateTo && data.guests ) {
                        this.$form.trigger('submit');
                    }
                });*/

                // registriran jednom, prije bi se na svaki klik polaska kreirao novi listener
                $(document).on('click', '.flight-ticket', e => {
                    this.setFlightTicket($(e.currentTarget));
                });

                this.getTravelProgram();
            }
        });
        
        //const departures = JSON.parse($('#details-datepicker').attr('data-departures'));
        //this.setDefaultDeparture(departures);
        //functions.setFormData(this.form, this.params);

        //this.showFlightTickets();
        //this.setPrices();

        this.params.adultsOnly = $('.input-guests').attr('data-adultsonly');

        if(this.params.guests) {

            this.params.guests = this.params.adultsOnly ? this.params.guests.split(',')[0] + ',0' : this.params.guests;

            $('[name=guests]').each((index, elem) => {
                $(elem).val(this.params.guests);

                let guests = this.params.guests.split(',');
                let i = 1;
                for (let index = 2; index < guests.length; index++) {
                    if(guests[index]) {
                        $('[name=child-age-'  + i + ']').val(guests[index]);
                    }
                    i++;
                }
            });
            $('[name=guests]').trigger('change');
        }

        
        if(! this.params.serviceCode && $('[name="serviceCode"]').length) {
            this.params.serviceCode = $('[name="serviceCode"]').val();
        }

        //this.getCalculation();

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $(window).on('hashchange', e => {
            this.getParams();
            this.params.guests = this.params.adultsOnly && this.params.guests ? this.params.guests.split(',')[0] + ',0' : this.params.guests;

            this.showFlightTickets();
            this.setPrices();
            this.printDates();

            this.getCalculation();
            
            this.showTravelProgram();
        });

        if(this.$cart.length) {
            $('.btn-booking').on('click', e => {
                e.preventDefault();
    
                if(! this.cart.cartItems.length) {
                    $('#detailsCartModal').modal('show');
                    setTimeout(() => {
                        $('#detailsCartModal').modal('hide');
                    }, 2500);
                }
            });
        }

    },
    getPackageDepartures(rates, flightTitles) {
        let departures = {};

        Object.keys(rates).forEach(index => {
            let rate = rates[index];
            let flight = rate.flight;
            let unique = rate.dateFrom + ',' + rate.dateTo + ',' + flight.timeDepartureFrom + ',' + flight.timeReturnFrom;

            let aDateFrom = rate.aDateFrom;
            let aDateTo = rate.aDateTo;

            let flightUnitId = flight.unitId;
            let unitId = rate['unitId']['id'];

            if ( ! departures[unique]) {
                let flightIds = {};
                flightIds[flightUnitId] = {};
                flightIds[flightUnitId][unitId] = rate.id;

                let flights = {};
                flights[flightUnitId] = flight;

                let rates = {};
                rates[rate.id] = rate;
                if ( flight.timeDepartureFrom ) {
                    flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
                }
                departures[unique] = {
                    'dateFrom'      : rate.dateFrom,
                    'dateTo'        : rate.dateTo,
                    'aDateFrom'     : aDateFrom,
                    'aDateTo'       : aDateTo,
                    'time'          : flight.time || '',
                    'duration'      : rate.accommodationDuration,
                    'nights'        : rate.accommodationDuration,
                    'flightUnitId'  : flightUnitId,
                    'flightIds'     : flightIds,
                    'flights'       : flights,
                    'rates'         : rates,
                };
            } else {
                let departure = departures[unique];

                if ( ! departure.flightIds[flightUnitId])
                {
                    let flightIds = {};
                    flightIds[flightUnitId] = {};
                    flightIds[flightUnitId][unitId] = rate.id;

                    departure.flightIds[flightUnitId] = {};
                    departure.flightIds[flightUnitId][unitId] = rate.id;
                }
                else if ( ! departure.flightIds[flightUnitId][unitId])
                {
                    departure.flightIds[flightUnitId][unitId] = rate.id;
                }

                departure.flights[flightUnitId] = flight;
                departure.rates[rate.id] = rate;
            }
        });

        this.departures = departures;

        let enable = [];
        let prices = {};
        let flights = [];

        Object.keys(departures).forEach(index => {
            let rate = departures[index];

            enable.push({
                dateFrom: rate['dateFrom'],
                dateTo: rate['dateTo'],
                duration: rate['duration'],
                nights: rate['duration'],
                time: rate['time'],
                flightUnitId: rate['flightUnitId'],
            });

            prices[index] = detailsPackage.getDeparturePrices(rate);

            let arrival = rate.dateFrom;
            let departure = rate.dateTo;

            let arrivalDay = detailsPackage.getWeekDay(arrival);
            let arrivalDayDeparture = detailsPackage.getWeekDay(departure);

            Object.keys(rate.flights).forEach(function(index) {

                let flight = rate.flights[index];

                let flightUnitId = flight['unitId'];
                let rateIds = rate['flightIds'][flightUnitId];

                let timeDepartureFrom = flight['timeDepartureFrom'];
                let timeDepartureTo = flight['timeDepartureTo'];
                let timeReturnFrom = flight['timeReturnFrom'];
                let timeReturnTo = flight['timeReturnTo'];
                let placeFromName = flight['placeFrom'];
                let placeToName = flight['placeTo'];
                let departureDuration = flight['departureDuration'];
                let returnDuration = flight['returnDuration'];
                let arrivalDate = flight['arrivalDate'];
                let returnDate = flight['returnDate'];
                let availabilityStatus = flight['availabilityStatus'];

                let flightTitle;
                flightTitles.forEach((ft) => {
                    if (ft.id == flight.objectId) {
                        flightTitle = ft.title ? ft.title : ft.supplierTitle;
                    }
                });

                flights.push({
                    dateFrom              : rate.dateFrom,
                    dateTo                : rate.dateTo,    
                    aDateFrom             : rate.aDateFrom,
                    aDateTo               : rate.aDateTo,
                    flightId              : flight.objectId,
                    flightTitle           : flightTitle,
                    flightUnitId          : flight.unitId,
                    rateIds               : rateIds,
                    arrivalDay            : arrivalDay,
                    arrivalDayDeparture   : arrivalDayDeparture,
                    timeDepartureFrom     : timeDepartureFrom,
                    timeDepartureTo       : timeDepartureTo,
                    timeReturnFrom        : timeReturnFrom,
                    timeReturnTo          : timeReturnTo,
                    time                  : flight.time,
                    placeFromName         : placeFromName,
                    placeToName           : placeToName,
                    departureDuration     : departureDuration,
                    returnDuration        : returnDuration,
                    arrivalDate           : arrivalDate,
                    returnDate            : returnDate,
                    availabilityStatus    : availabilityStatus,
                });
            });

        });

        return {
            enable : enable,
            prices : prices,
            flights : flights
        };

    },
    getDeparturePrices(rate) {
        let departurePrices = {};
        let flights = rate.flightIds;
        let rates = rate.rates;

        Object.keys(flights).forEach(function(flightId) {
            let items = flights[flightId];
            Object.keys(items).forEach(function(unitId) {
                let rateId = items[unitId];
                let unitRate = rates[rateId];

                if (unitRate) {

                    let validUntil = null;
                    if (unitRate.specialDiscount && unitRate.specialDiscount.validUntil) {
                        validUntil = unitRate.specialDiscount.validUntil;
                    }

                    var flightUnitId = flightId;

                    if ( ! departurePrices[unitId]) departurePrices[unitId] = {};

                    departurePrices[unitId][flightUnitId] = {
                        price : '€ ' + functions.formatMoney(unitRate.price, 0, '', ''),
                        priceWithDiscount : unitRate.priceWithDiscount ? ('€ ' + functions.formatMoney(unitRate.priceWithDiscount, 0, '', '')) : null,
                        discountTitle : unitRate.specialDiscount && unitRate.specialDiscount.itemDefinitionId.text ? unitRate.specialDiscount.itemDefinitionId.text : null,
                        validUntil : validUntil,
                        paymentKey : unitRate.paymentTypeKey == 'Once' ? 'po boravku' : 'po osobi'
                    };
                }
            });
        });

        return departurePrices;
    },
    getWeekDay(date) {

        const d = new Date(date);
        const days = [
            "nedelja",
            "ponedeljak",
            "utorak",
            "sreda",
            "četvrtak",
            "petak",
            "subota"
        ];

        let day = d.getDay()

        return days[day];
    },
    setPrices() {

        let guests = this.params.guests && ! this.params.guests.startsWith('0');
        
        if( ! guests) {

            if (this.params.isBrosTravel) {
                $('.fm-discount').addClass('d-none');
                $('.fm-discount-title').addClass('d-none');
            } else {
                let prices = JSON.parse($('[data-prices]').attr('data-prices'));
                prices = prices[this.params.dateFrom + ',' + this.params.dateTo + ',' + this.params.time];
                this.loader();

                $('.unit').attr('style', 'order: 10000');
                if(prices) {
                    setTimeout(() => {
                        Object.entries(prices).forEach(item => {
                            const unitId = item[0];

                            const flightUnitId = $('.flight-ticket.active').attr('data-flightunitid');
                            const rate = item[1][flightUnitId];

                            const $unit = $('.unit[data-unitid="' + unitId + '"]');

                            $unit.removeClass('d-none');
                            //$unit.find('.unit-price-old').text(rate.priceWithDiscount ? rate.price : '');
                            //$unit.find('.unit-price-total').text(rate.priceWithDiscount ? rate.priceWithDiscount : rate.price);

                            let price = rate.priceWithDiscount ? rate.priceWithDiscount : rate.price;
                            price = price.replace('€ ', '');
                            price = price.replace('.', '');
                            let order = parseInt(price);
                            $unit.prop('style', 'order: ' + order);

                            const $fmDiscount = $unit.find('.fm-discount:not(.fm-discount-custom)');
                            if($fmDiscount.length) {
                                $fmDiscount.addClass('d-none');
                                //$fmDiscount.toggleClass('d-none', ! rate.discountTitle);

                                //$fmDiscount.find('.fm-discount-title').text(rate.discountTitle ? rate.discountTitle : '');
                                //$fmDiscount.find('.fm-discount-title').toggleClass('d-none', rate.validUntil != null);

                                //$fmDiscount.find('.fm-discount-valid-until').toggleClass('d-none', ! rate.validUntil);
                                //$fmDiscount.find('.fm-discount-valid-until-date').text(rate.validUntil ? functions.formatDate(rate.validUntil) : '');
                            }

                            //$unit.find('.unit-price-payment-key').text(rate.paymentKey ? rate.paymentKey : '');

                        });

                        $('.unit').each((index, unit) => {
                            const $unit = $(unit);
                            const unitId = $unit.attr('data-unitid');
                            ! prices[unitId] && $unit.addClass('d-none');
                        });
                    }, 800);
                }
            }
        }

    },
    showFlightTickets() {

        const dataFlights = JSON.parse($('[data-flights]').attr('data-flights'));

        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;

        let flights = dataFlights.filter(flight => {
            return flight.dateFrom == dateFrom && flight.dateTo == dateTo;
        });

        // Fly Dubai on first place
        let flyDubai = flights.find(({flightId}) => flightId == 43440);
        if(flyDubai) {
            flights = flights.filter(flight => { return flight != flyDubai });
            flights.unshift(flyDubai);
        }

        this.renderFlightTickets(flights);

    },
    renderFlightTickets(flights) {
        const $flights = $('.flights').empty();
        
        flights.forEach((flight, index) => {
            const time = flight.timeDepartureFrom + ',' + flight.timeReturnFrom;
            this.params.time = ! this.params.time && index == 0 ? time : this.params.time;

            //const isFlyDubai = flight.flightId == 43440;
            // ${ isFlyDubai ? ' show-first order-0' : ' order-1' }
            
            $flights.append(`
                <div class="flight-ticket${ ! this.params.time && index == 0 ? ' active' : (time == this.params.time ? ' active' : '') }"
                    data-flight='${ JSON.stringify(flight) }' 
                    data-flightId="${ flight.flightId }"
                    data-flightUnitId="${ flight.flightUnitId }"
                    data-rateIds='${ JSON.stringify(flight.rateIds) }'
                    data-dateFrom="${ flight.dateFrom }"
                    data-dateTo="${ flight.dateTo }"
                    data-aDateFrom="${ flight.aDateFrom }"
                    data-aDateTo="${ flight.aDateTo }"
                    data-time="${ time }"
                    data-flightTitle="${ flight.flightTitle || '' }"
                    data-flightStatus="${ flight.availabilityStatus || '' }"
                    >
                    <div class="row g-0">
                        <div class="col">
                            <div class="flight-ticket-body">
                                ${ flight.flightTitle ? '<div class="flight-ticket-company">' + flight.flightTitle + '</div>' : '' }
                                <div class="flight-ticket-content">
                                    <div class="row">
                                        <div class="col-lg">
                                            <div class="flight-ticket-departure">
                                                <div class="departure-header">
                                                    <i class="las la-plane-departure la-2x"></i>
                                                    <div class="departure-label">Odlazak</div>
                                                    <div class="departure-date" data-flight-DateFrom>${ functions.formatDate(flight.dateFrom) }</div>
                                                    <div class="departure-day" data-flight-DateFromDay>${ flight.arrivalDay }</div>
                                                </div>
                                                <div class="row gx-2">
                                                    <div class="col-lg-auto">
                                                        <div class="departure-place-from">${ flight.placeFromName }</div>
                                                        <div class="departure-time-from" data-flight-TimeDepartureFrom>${ flight.timeDepartureFrom ? flight.timeDepartureFrom : '' }</div>
                                                    </div>
                                                    <div class="col-auto col-lg d-none d-lg-flex flex-column align-items-center">
                                                        <div class="w-100 bg-primary mt-2" style="height: 1px;"></div>
                                                        ${ flight.departureDuration ? '<div class="small fw-bold text-muted mt-1" style="line-height: 1.1rem;"><small>Trajanje</small></div><div class="small fw-bold text-muted" style="line-height: 1.1rem;"><small>' + flight.departureDuration + 'h</small></div>' : '' }
                                                    </div>
                                                    <div class="col-lg-auto text-end">
                                                        <div class="departure-place-to">${ flight.placeToName }</div>
                                                        <div class="departure-time-to" data-flight-TimeDepartureTo>${ flight.arrivalDate && flight.arrivalDate != flight.dateFrom ? '<small class="text-muted">' + functions.formatDate(flight.arrivalDate) + '</small> ' : '' }${ flight.timeDepartureTo ? flight.timeDepartureTo : '' }</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-auto">
                                            <div class="d-none d-lg-block h-100 bg-dark" style="width: 1px;"></div>
                                            <div class="d-block d-lg-none w-100 bg-dark mb-2" style="height: 1px;"></div>
                                        </div>
                                        <div class="col-lg">
                                            <div class="flight-ticket-retrun">
                                                <div class="return-header">
                                                    <i class="las la-plane-arrival la-2x"></i>
                                                    <div class="return-label">Povratak</div>
                                                    <div class="return-date" data-flight-DateTo>${ functions.formatDate(flight.dateTo) }</div>
                                                    <div class="return-day" data-flight-DateToDay>${ flight.arrivalDayDeparture }</div>
                                                </div>
                                                <div class="row gx-2">
                                                    <div class="col-12 col-lg-auto d-flex flex-row flex-lg-column justify-content-between">
                                                        <div class="return-place-from">${ flight.placeToName }</div>
                                                        <div class="return-time-from" data-flight-TimeReturnFrom>${ flight.returnDate && flight.returnDate != flight.dateTo ? '<small class="text-muted">' + functions.formatDate(flight.returnDate) + '</small> ' : '' }${ flight.timeReturnFrom ? flight.timeReturnFrom : '' }</div>
                                                    </div>
                                                    <div class="col-lg d-none d-lg-flex flex-column align-items-center">
                                                        <div class="w-100 bg-primary mt-2" style="height: 1px;"></div>
                                                        ${ flight.returnDuration ? '<div class="small fw-bold text-muted mt-1" style="line-height: 1.1rem;"><small>Trajanje</small></div><div class="small fw-bold text-muted" style="line-height: 1.1rem;"><small>' + flight.returnDuration + 'h</small></div>' : '' }
                                                    </div>
                                                    <div class="col-12 col-lg-auto text-end d-flex flex-row flex-lg-column justify-content-between">
                                                        <div class="return-place-to">${ flight.placeFromName }</div>
                                                        <div class="return-time-to" data-flight-TimeReturnTo>${ flight.timeReturnTo ? flight.timeReturnTo : '' }</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="ticket-tail">
                                <div class="ticket-tail-check">
                                    <i class="las la-check la-lg"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `);
        });

        this.params.aDateFrom = $('.flight-ticket.active').attr('data-adatefrom');
        this.params.aDateTo = $('.flight-ticket.active').attr('data-adateto');
    },
    /*showFlightTickets() {

        $('.flight-ticket').addClass('d-none');
        
        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;
        let time = this.params.time;

        const $tickets = $('.flight-ticket[data-datefrom="' + dateFrom + '"][data-dateto="' + dateTo + '"]');
        $tickets.removeClass('d-none');

        let $ticket = $tickets.first();
        $tickets.each((index, ticket) => {
            if ($(ticket).attr('data-time') == time) {
                $ticket = $(ticket);
                return false;
            }

            $ticket = $(ticket).hasClass('show-first') ? $(ticket) : $ticket;
        });

        // set active ticket
        this.setFlightTicket($ticket);
    },*/
    setFlightTicket($ticket) {
        // kopirana logika što je bila u eventu onclick ovdje
        // problem je bio što se nije popunilo vrijeme, iako ga imamo, inicijalno na prvi load detalja
        // i onda katarinin servis bi vratio "let je rasprodat" iako nije...
        $('.flight-ticket').removeClass('active');
        $ticket.addClass('active');

        this.setUnitRateIds($ticket);
        this.getParams();
        let time = $ticket.attr('data-time');
        let aDateFrom = $ticket.attr('data-adatefrom');
        let aDateTo = $ticket.attr('data-adateto');

        $('[name="time"]').val(time);
        $('[name="aDateFrom"]').val(aDateFrom);
        $('[name="aDateTo"]').val(aDateTo);

        this.params.time = time;
        this.params.aDateFrom = aDateFrom;
        this.params.aDateTo = aDateTo;

        this.$form.change();
    },
    setUnitRateIds($target) {
        if($target.attr('data-rateids')) {
            const rateIds = JSON.parse($target.attr('data-rateids'));
            const flightId = this.params.flightId = $target.attr('data-flightid');
            const flightUnitId = this.params.flightUnitId = $target.attr('data-flightunitid');
            Object.entries(rateIds).forEach(item => {
                const unitId = item[0];
                const rateId = item[1];
    
                $('.add-to-cart[data-unitid=' + unitId + ']').attr('data-rateid', rateId);
                $('.add-to-cart[data-unitid=' + unitId + ']').attr('data-flightid', flightId);
                $('.add-to-cart[data-unitid=' + unitId + ']').attr('data-flightunitid', flightUnitId);
    
                $('.btn-booking[data-unitid=' + unitId + ']').attr('data-rateid', rateId);
                $('.btn-booking[data-unitid=' + unitId + ']').attr('data-flightid', flightId);
                $('.btn-booking[data-unitid=' + unitId + ']').attr('data-flightunitid', flightUnitId);
            });
        }
    },
    setDefaultDeparture(departures) {
        this.params.dateFrom = ! this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateFrom : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateTo : this.params.dateTo;

        let departure = this.departures ? this.departures[this.params.dateFrom + ',' + this.params.dateTo] : null;
        departure && (this.params.time = departure.time);
        
        departure = departure || this.departures[this.params.dateFrom + ',' + this.params.dateTo + ',' + this.params.time]
        this.params.aDateFrom = departure && departure.aDateFrom ? departure.aDateFrom : null;
        this.params.aDateTo = departure && departure.aDateTo ? departure.aDateTo : null;

        //this.params.dateFrom = ! this.params.dateFrom && departures.length ? departures[0].dateFrom : this.params.dateFrom;
        //this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && departures.length ? departures[0].dateTo : this.params.dateTo;
    },
    printDates() {
        $('.unit-departure').addClass('fade');
        setTimeout(() => {
            $('.unit-departure').removeClass('fade');
            $('.date-from').text(functions.formatDate(this.params.dateFrom));
            $('.date-to').text(functions.formatDate(this.params.dateTo));
            //$('.overnights').text($('.departure[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']').attr('data-duration'));
        }, 800);

    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;
        const calculation = details.getCalculation(cParams);
        if(calculation) {
            this.loader(this.params.unitId ? $('.unit[data-unitid=' + this.params.unitId + ']').find('.unit-spinner') : null);
            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                }).fail(error => {
                    console.log(error);
                });
        } else {

            //this.setPrices();


            ! this.params.showCart && $('.btn-booking').toggleClass('d-none', true);
            $('.add-to-cart').toggleClass('d-none', true);

            $('.no-period-label').toggleClass('d-none', false);
            $('.availablility-label').toggleClass('d-none', true);

            $('.unit-error-container').toggleClass('d-none', true);

            $('.unit-price-total-label').toggleClass('d-none', true);
            $('.unit-price-label').toggleClass('d-none', false);

            $('.unit-price-payment-key').toggleClass('d-none', false);
        }
    },
    calculationDone(response, params) {
        if(response.status) {
            const data = response.data || [];
            params.serviceCode = params.serviceCode ? encodeURIComponent(params.serviceCode) : params.serviceCode;

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');
                const $addToCart = $unit.find('.add-to-cart');
                const $fmDiscount = $unit.find('.fm-discount:not(.fm-discount-custom)');

                let discountTitle = null;

                if(details.isBookable(unitData)) {
                    const unitCalc = unitData.calc;
                    const calcItems = unitCalc.items;
                    const total = unitCalc.total.toFixed(2);
                    const currencySymbol = unitCalc.currencySymbol;

                    let priceOld = details.getCalcTotalOld(calcItems);
                    priceOld = +priceOld.toFixed(2);
                    discountTitle = details.getCalcDiscountTitle(calcItems);

                    if(discountTitle && $fmDiscount.length) {
                        $unit.find('.unit-price-discount-title').text(discountTitle);
                        $unit.find('.fm-discount-title').text(discountTitle);
                        $unit.find('.fm-discount-title').toggleClass('d-none', false);
                    }

                    $unit.find('.unit-price-old').text(priceOld > total ? currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',') : '');
                    
                    //$unit.find('.unit-price-total-label').removeClass('d-none');
                    $unit.find('.unit-price-total').text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));
                    
                    //this.printDates();

                    if(this.$cart.length) {
                        $addToCart.attr('data-unitcarttotal', total);
                        $addToCart.attr('data-unitcarttotalold', priceOld);
                        $addToCart.attr('data-currencysymbol', currencySymbol);
    
                        $addToCart.attr('data-datefrom', params.dateFrom);
                        $addToCart.attr('data-dateto', params.dateTo);
                        $addToCart.attr('data-guests', params.guests);

                        $addToCart.attr('data-adatefrom', params.aDateFrom);
                        $addToCart.attr('data-adateto', params.aDateTo);

                        $addToCart.attr('data-servicecode', params.serviceCode);
                        $addToCart.attr('data-flightunitid', params.flightUnitId);
                        $addToCart.attr('data-time', params.time);
                    } else {
                        const $btnBooking = $unit.find('.btn-booking[data-unitId=' + unitId + ']');

                        $btnBooking.text( !this.params.isBrosLive && unitData.booking.status == 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));

                        $btnBooking.on('click', e => {
                            e.preventDefault();

                            let cartData = [
                                {
                                    'unitId': unitId,
                                    'dateFrom': params.dateFrom,
                                    'dateTo': params.dateTo,
                                    'aDateFrom': params.aDateFrom,
                                    'aDateTo': params.aDateTo,
                                    'guests': params.guests,
                                    'pricelistId': params.pricelistId,
                                    'serviceCode': params.serviceCode,
                                    'optionals': params.optionals,
                                    'dynamicPackage': 1,
                                    'time': params.time,
                                }
                            ];

                            location = $(e.currentTarget).attr('data-href') + '?dynamicPackage=1&cart_data=' + JSON.stringify(cartData);
                        });

                        /*const $btnBooking = $unit.find('.btn-booking[data-unitId=' + unitId + ']');
                        //const rateId = $btnBooking.attr('data-rateid');
                        //const flightId = $btnBooking.attr('data-flightid');
                        const flightUnitId = $btnBooking.attr('data-flightunitid');
    
                        $btnBooking.text(unitData.booking.status == 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));
    
                        if($btnBooking.attr('data-href')) {
                            $btnBooking.attr('data-href',
                                $btnBooking.attr('data-href').split('?')[0] +
                                '?objectGroupId=' + this.params.objectGroupId +
                                '&unitId=' + unitId +
                                '&dateFrom=' + this.params.dateFrom +
                                '&dateTo=' + this.params.dateTo +
                                '&guests=' + this.params.guests +
                                '&addAllOptionals=1' + 
                                '&dynamicPackage=1' + 
                                '&flightUnitId=' + flightUnitId
                                //'&pricelistItemId=' + rateId
                            );
                        }
    
                        $btnBooking.on('click', e => {
                            e.preventDefault();
                            location = $(e.currentTarget).attr('data-href');
                        });*/
                    }

                    $unit.prop('style', 'order: ' + parseInt(total));

                } else {
                    $unit.prop('style', 'order: 10000;');
                }

                $unit.find('.unit-price-total-label').toggleClass('d-none', ! details.isBookable(unitData));

                $unit.find('.unit-price-label').toggleClass('d-none', details.isBookable(unitData));
                $unit.find('.unit-price').toggleClass('d-none', ! details.isBookable(unitData));

                $unit.find('.unit-price-discount-title').toggleClass('d-none', ! details.isBookable(unitData));
                $unit.find('.unit-price-payment-key').toggleClass('d-none', details.isBookable(unitData));

                if($fmDiscount.length) {
                    $unit.find('.fm-discount').toggleClass('d-none', discountTitle == null || ! details.isBookable(unitData));
                    
                    $unit.find('.fm-discount-valid-until').toggleClass('d-none', details.isBookable(unitData));
                    //$unit.find('.fm-discount-valid-until-date').text(rate.validUntil ? rate.validUntil : '');
                }

                //$unit.find('.no-period-label').toggleClass('d-none', details.isBookable(unitData));

                ! this.params.showCart && $unit.find('.btn-booking').toggleClass('d-none', ! details.isBookable(unitData));
                $unit.find('.add-to-cart').toggleClass('d-none', ! details.isBookable(unitData));

                //$unit.find('.btn-booking-container').toggleClass('d-none', ! details.isBookable(unitData));
                //$unit.find('.btn-request-nobookable').toggleClass('d-none', details.isBookable(unitData));

                let error = details.getCalcErrorMessage(this.params.calcErrorMessages, unitData);
                $unit.find('.unit-error-container').toggleClass('d-none', details.isBookable(unitData));
                $unit.find('.unit-error-container').text(error);

                $unit.find('.availablility-label').toggleClass('d-none', unitData.message != 'notAvailable');
                //$unit.find('.no-period-label').toggleClass('d-none', unitData.message == 'notAvailable' || details.isBookable(unitData));
                $unit.find('.no-period-label').toggleClass('d-none', ! unitData.message && details.isBookable(unitData));
                $unit.find('.unit-price-label').toggleClass('d-none', true);
                params.pricelistId = params.pricelistId ? params.pricelistId : $unit.attr('data-pricelistid');

            });

            if(this.$cart.length) {
                const $btnBooking = $('.btn-booking');
    
                $btnBooking.on('click', e => {
                    e.preventDefault();
                    let cartData = [];
    
                    this.cart.cartItems.forEach(item => {
                        item = JSON.parse(item);
                        cartData.push({
                            'unitId': item.unitId,
                            'dateFrom': item.dateFrom,
                            'dateTo': item.dateTo,
                            'aDateFrom': item.aDateFrom,
                            'aDateTo': item.aDateTo,
                            'guests': item.guests,
                            'flightUnitId': item.flightUnitId,
                            'time': item.time,
                            'serviceCode': item.serviceCode,
                            'pricelistId': params.pricelistId,
                            'dynamicPackage': 1,
                        });
                    });
                    let url = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=1';

                    if(this.cart.cartItems.length) {
                        location = url;
                    } else {
                        $('#detailsCartModal').modal('show');
                        setTimeout(() => {
                            $('#detailsCartModal').modal('hide');
                        }, 2500);
                    }

                    //location = url;
                });
            }
        }
    },
    loader($target = null) {
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 800);
    },
    getTravelProgram() {
        const programURL = $('[data-programurl]').length ? $('[data-programurl]').attr('data-programurl') : null;

        if(programURL) {
            $.get(programURL).done(response => {
                this.travelProgram = $(response).find('.entry-content').html();
                this.showTravelProgram();
            }).fail(e => {
                $('.travel-program-link').addClass('d-none');
            });
        }
    },
    showTravelProgram() {
        const $flightTicket = $('.flight-ticket.active'); 
        const flightStatus = $flightTicket.attr('data-flightstatus');

        let flightTitle = $flightTicket.attr('data-flighttitle');
        flightTitle = flightTitle ? flightTitle.replaceAll(' ', '') : flightTitle;

        let tabId = flightStatus == 'Fix' ? flightTitle + '-' + flightStatus : flightTitle;

        let html = $(this.travelProgram).find('.tab-pane[id=' + tabId + ']').html();
        $('#travelProgramModal').find('.modal-body').html(html);
        $('.travel-program-link').removeClass('d-none');
    },
};
